// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3fwVm","selects":"Documents_selects__3l4XH"};